export default {"src":"/_next/static/media/risk.a4fc04ce.svg","height":54,"width":51};